import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { useQuery } from '@tanstack/react-query';

export interface ClientOption {
    id: number;
    name: string;
}

export const useClientsDropdown = () => {
    const httpClient = createHttpClient(apiClientWH);

    const { data, isLoading } = useQuery({
        queryKey: ['teams-child-dropdown'],
        queryFn: async () => {
            try {
                const response = await httpClient.get<any>('/teams-child', { limit: 100 });
                // El endpoint devuelve { data: [...] }
                const clients = response?.data || response || [];
                return clients.map((client: any) => ({
                    id: client.id,
                    name: client.name,
                })) as ClientOption[];
            } catch (error) {
                console.error('Error loading clients:', error);
                return [];
            }
        },
        staleTime: 5 * 60 * 1000, // 5 minutos
        gcTime: 10 * 60 * 1000, // 10 minutos
    });

    return {
        clients: data ?? [],
        isLoading,
    };
};

